import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";

import SmallBox from "./small_box";
import { getBoxSize } from "helpers/review-boxsize-helper";

const SmallBoxedSizesContainer = ({ chosenValue, setChosenValue, sizeNames, sizes }) => {
  const ref = useRef(null);
  const [hasShadow, sethasShadow] = useState(false);

  useEffect(() => {
    sethasShadow(ref.current.scrollHeight > ref.current.getBoundingClientRect().height);
  }, []);

  return (
    <div className={`reviews_filters-size_filter-boxes_container ${hasShadow && "add-bottom-shadow"}`} ref={ref}>
      {sizes.map(function (eachSize) {
        return (
          <SmallBox
            key={`small-box-${eachSize}`}
            chosenValue={chosenValue}
            setChosenValue={setChosenValue}
            text={sizeNames[eachSize]}
            keyName={eachSize}
            size={getBoxSize(Object.values(sizeNames))}
          />
        );
      })}
    </div>
  );
};

SmallBoxedSizesContainer.propTypes = {
  chosenValue: PropTypes.array.isRequired,
  setChosenValue: PropTypes.func.isRequired,
  sizeNames: PropTypes.object.isRequired,
  sizes: PropTypes.array.isRequired,
};

export default SmallBoxedSizesContainer;
